import { useLocation } from 'react-router-dom'
import { isProductAppPath } from '../../constants/productAppRoutes'

const DEFAULT_ALLOW =
  'accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;'

/**
 * Mux (or any) player iframe that must not render on corporate/marketing routes.
 * Prefer this over a raw `<iframe>` for product-only videos; it enforces `isProductAppPath`.
 * Intentional marketing embeds (LandingPage, DocumentationPage) should keep a normal iframe.
 */
export default function ProductMuxIframe({
  src,
  title,
  className,
  allow = DEFAULT_ALLOW,
  allowFullScreen = true,
}) {
  const { pathname } = useLocation()
  if (!isProductAppPath(pathname)) return null
  return (
    <iframe
      src={src}
      className={className}
      allow={allow}
      allowFullScreen={allowFullScreen}
      title={title}
    />
  )
}
